import { render, staticRenderFns } from "./Soil-Scouts.vue?vue&type=template&id=00927e60"
import script from "./Soil-Scouts.vue?vue&type=script&lang=js"
export * from "./Soil-Scouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports